var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.RouterAlive)?_c('div',[_c('layout-header'),_vm._v(" "),_c('menu-pc'),_vm._v(" "),_c('menu-mobile'),_vm._v(" "),_c('router-view',{staticClass:"main-content"}),_vm._v(" "),_c('layout-footer'),_vm._v(" "),_c('layout-copyright')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7918d58e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout/Layout.vue
// module id = null
// module chunks = 